"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

require("./form-label.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function FormLabel(props) {
  var className = props.className,
      label = props.label,
      error = props.error,
      helperText = props.helperText,
      shouldPrependErrors = props.shouldPrependErrors,
      children = props.children,
      rest = _objectWithoutProperties(props, ["className", "label", "error", "helperText", "shouldPrependErrors", "children"]);

  return _react.default.createElement("div", {
    className: className
  }, label && _react.default.createElement("div", {
    className: "ml-2 relative leading-none z-10"
  }, _react.default.createElement("label", _extends({
    className: "form-label text-xs font-bold tracking-wide px-1 pb-1 bg-white text-grey-darker"
  }, rest), label)), children, error ? _react.default.createElement("div", {
    className: "pt-1 text-xs text-red-600"
  }, shouldPrependErrors ? "".concat(_lodash.default.startCase(label), " ").concat(error) : error) : helperText ? _react.default.createElement("div", {
    className: "pt-1 text-xs text-gray-medium"
  }, helperText) : null);
}

FormLabel.propTypes = {
  className: _propTypes.default.string,
  label: _propTypes.default.string,
  error: _propTypes.default.string,
  helperText: _propTypes.default.string,
  shouldPrependErrors: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired
};
FormLabel.defaultProps = {
  className: '',
  error: null,
  shouldPrependErrors: true
};

var _default = _react.default.memo(FormLabel);

exports.default = _default;